import React, { useMemo } from 'react';
import { Tooltip } from '../helpers/Tooltip';
import { useMapContext } from './context/MapContext';

export type MapTooltipProps = {
  sticky?: boolean;
  position?: { x: number; y: number };
  visible?: boolean;
  style?: React.CSSProperties;
  className?: string;
  maxWidth?: number;
  children: React.ReactNode | React.ReactNode[];
};

export const MapTooltip: React.FC<MapTooltipProps> = ({
  sticky = true,
  position,
  visible = false,
  children,
  style,
  className,
}) => {
  const { map } = useMapContext();
  const mapContainer = useMemo(() => map?.getTargetElement(), [map]);

  return (
    <Tooltip
      sticky={sticky}
      position={position}
      visible={visible}
      style={style}
      className={className}
      container={mapContainer}
    >
      {children}
    </Tooltip>
  );
};
